import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_maintain_only_one_accurate_payroll_record'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_maintain_only_one_accurate_payroll_record',
  name: 'Does the facility maintain only one accurate payroll record?',
  description:
    'The intent of this question is to understand if the facility maintains one payroll record only for workers and if it is accurate (reflecting actual facility operations) and complete (the record is maintained for all workers). \r\r\n\r\r\nNote, that should any legal non-compliances regarding the maintenance of the payroll record be identified by the Verifier/ Assessor, a legal Non-Compliance will be applied for this question.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-2--2',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7230,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
